<template>
  <v-container class="fill-height">
    <v-row align="center" class="text-center" style="height: 100vh;">
      <v-col cols="12" style="position: absolute; top: calc(100vh - 64px); width: 100%; left: 0px;">
        <div class="mb-5">
          <v-icon class="pb-1 mr-1">mdi-console</v-icon>
          Fullstack Dev. - Mainly :: Node, Deno & .NET
        </div>
      </v-col>
      <v-col cols="12">
        <h1 class="display-3 font-weight-bold mb-5">
          <span class="text-primary">
            Basilius Bias Astho Christyono
          </span>
        </h1>
        <v-divider></v-divider>
        <h2 class="subheading font-weight-regular mt-5">
          <v-row>
            <v-col cols="12" sm="6" class="py-0">
              <v-icon class="pb-1 mr-1">mdi-briefcase-outline</v-icon>
              Software Engineer
            </v-col>
            <v-col cols="12" sm="6" class="py-0">
              <v-icon class="pb-1 my-1">mdi-map-marker-outline</v-icon>
              Jakarta, Indonesia
            </v-col>
          </v-row>
        </h2>
      </v-col>
    </v-row>
    <v-row align="center" class="my-5">
      <v-col cols="12">
        <v-card>
            <v-row class="ma-0">
              <v-col cols="12" sm="5">
                <v-img class="ma-5" src="../assets/photo.png" ></v-img>
              </v-col>
              <v-col cols="12" sm="7">
                <v-card-title>
                  <h3 class="display-1 font-weight-bold mb-3">
                    About Me
                  </h3>
                </v-card-title>
                <v-card-subtitle>
                  <h3 class="subheading font-weight-regular my-3">
                    📌 Interest in <b>software</b>, <b>web</b>, <b>data mining</b>, and <b>distributed systems</b> &amp; <b>networks</b>
                    <br />
                    ✨ TOEIC L&R - ETS :: 765 (Exp. March 19, 2026)
                    <br /><br />
                    📃 <a target="_blank" href="https://bifeldy.github.io/cv.html" class="text-decoration-none">View Resume</a>
                    <br />
                    🔗 <a target="_self" href="#MyJourney" class="text-decoration-none">My Journey</a>
                  </h3>
                  <v-row class="my-3">
                    <v-col cols="12" md="4">
                      <v-row>
                        <v-col cols="12">
                          <h2 class="subheading font-weight-bold mt-3">
                            Frontend
                          </h2>
                        </v-col>
                        <v-col cols="12" class="py-0 px-3">
                          <v-btn icon x-large>
                            <v-icon>mdi-angular</v-icon>
                          </v-btn>
                          <v-btn icon x-large>
                            <v-icon>mdi-android</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <h2 class="subheading font-weight-bold mt-3">
                            Backend / Full
                          </h2>
                        </v-col>
                        <v-col cols="12" class="py-0 px-3">
                          <v-btn icon x-large>
                            <v-icon>mdi-nodejs</v-icon>
                          </v-btn>
                          <v-btn icon x-large>
                            <v-icon>mdi-dot-net</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-row>
                        <v-col cols="12">
                          <h2 class="subheading font-weight-bold mt-3">
                            Clouds
                          </h2>
                        </v-col>
                        <v-col cols="12" class="py-0 px-3">
                          <v-btn icon x-large>
                            <v-icon>mdi-aws</v-icon>
                          </v-btn>
                          <v-btn icon x-large>
                            <v-icon>mdi-google-cloud</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <h2 class="subheading font-weight-bold mt-3">
                            Others
                          </h2>
                        </v-col>
                        <v-col cols="12" class="py-0 px-3">
                          <v-btn icon x-large>
                            <v-icon>mdi-language-html5</v-icon>
                          </v-btn>
                          <v-btn icon x-large>
                            <v-icon>mdi-language-css3</v-icon>
                          </v-btn>
                          <v-btn icon x-large>
                            <v-icon>mdi-language-javascript</v-icon>
                          </v-btn>
                          <v-btn icon x-large>
                            <v-icon>mdi-language-typescript</v-icon>
                          </v-btn>
                          <v-btn icon x-large>
                            <v-icon>mdi-language-csharp</v-icon>
                          </v-btn>
                          <v-btn icon x-large>
                            <v-icon>mdi-language-python</v-icon>
                          </v-btn>
                          <v-btn icon x-large>
                            <v-icon>mdi-language-java</v-icon>
                          </v-btn>
                          <v-btn icon x-large>
                            <v-icon>mdi-language-c</v-icon>
                          </v-btn>
                          <v-btn icon x-large>
                            <v-icon>mdi-language-cpp</v-icon>
                          </v-btn>
                          <v-btn icon x-large>
                            <v-icon>mdi-language-kotlin</v-icon>
                          </v-btn>
                          <v-btn icon x-large>
                            <v-icon>mdi-language-go</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-subtitle>
              </v-col>
            </v-row>
          </v-card>
      </v-col>
    </v-row>
    <v-row align="center" class="text-center mb-5">
      <v-col cols="12" align="start" class="text-start">
        <h2 class="d-flex justify-space-between flex-row">
          <span class="text-left">Experience</span>
          <small class="text-right">
            <a target="_blank" href="https://www.linkedin.com/in/Bifeldy" class="text-decoration-none">More</a>
          </small>
        </h2>
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" align="start">
        <v-slide-group show-arrows>
          <v-slide-item class="mx-3" v-for="w in works" :key="w.date" v-slot="{ active, toggle }">
            <v-card class="ma-3" width="512" @click="toggle">
              <v-row v-if="!active">
                <v-col cols="4">
                  <v-img :src="require(`@/assets/${w.image}`)"></v-img>
                </v-col>
                <v-col cols="8">
                  <v-card-text class="text-center px-0">
                    <p class="text-start">
                      <span>{{ w.job }}</span>
                      <span class="me-4" style="position: absolute; right: 0;">{{ w.type }}</span>
                    </p>
                    <p class="text-h5 text-primary mb-1">{{ w.company }}</p>
                    <p class="mb-0">{{ w.date }}</p>
                    <p class="mb-0">{{ w.location }}</p>
                  </v-card-text>
                </v-col>
              </v-row>
              <v-row v-if="active">
                <v-card-text class="text-start ma-4" v-if="active">
                  <h3 class="text-primary mb-1">{{ w.industry }}</h3>
                  <p class="mb-0">{{ w.description }}</p>
                </v-card-text>
              </v-row>
            </v-card>
          </v-slide-item>
        </v-slide-group>
      </v-col>
    </v-row>
    <v-row align="center" class="text-center mb-5">
      <v-col cols="12" align="start" class="text-start">
        <h2 class="d-flex justify-space-between flex-row">
          <span class="text-left">Research &amp; Paper Work</span>
          <small class="text-right">
            <a target="_blank" href="https://kc.umn.ac.id/cgi/search/archive/advanced?creators_name=Christyono" class="text-decoration-none">More</a>
          </small>
        </h2>
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" align="start">
        <v-timeline align-top dense>
          <v-timeline-item color="pink" small v-for="p in papers" :key="p.date">
            <v-row class="pt-1 text-start">
              <v-col cols="12" md="3">
                {{ p.publisher }} <br />
                {{ p.date }}
              </v-col>
              <v-col>
                <strong>{{ p.title }}</strong>
                <div class="text-caption mb-2">
                  {{ p.description }} <br />
                  <a :href="p.url" class="text-decoration-none d-inline-block text-truncate" style="max-width: 100%;">
                    {{ p.url }}
                  </a>
                </div>
                <v-avatar v-for="i in p.images" :key="i">
                  <v-img :src="i"></v-img>
                </v-avatar>
              </v-col>
            </v-row>
          </v-timeline-item>
        </v-timeline>
      </v-col>
    </v-row>
    <v-row align="center" class="text-center mb-5">
      <v-col cols="12" align="start" class="text-start">
        <h2 class="d-flex justify-space-between flex-row">
          <span class="text-left">Featured Hobby</span>
          <small class="text-right">
            <a target="_blank" href="https://github.com/bifeldy?tab=repositories" class="text-decoration-none">More</a>
          </small>
        </h2>
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" align="start">
        <v-row align="center" justify="center">
          <v-col v-for="p in projects" :key="p.name" cols="12" sm="6" md="4">
            <v-card class="mx-auto">
              <v-img height="128" :src="p.image"></v-img>
              <v-card-item>
                <div class="px-3 py-3">
                  <div class="text-overline mb-1">{{ p.name }}</div>
                  <div class="text-h6 mb-1">{{ p.title }}</div>
                  <div class="text-caption">{{ p.description }}</div>
                </div>
              </v-card-item>
              <v-card-actions>
                <v-btn @click="openUrl(`https://github.com/bifeldy/${p.name}`)">Open</v-btn>
                <v-btn @click="openUrl(p.url)" v-if="p.url">Visit</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row align="center" class="text-center mb-5" id="MyJourney">
      <v-col cols="12">
        <span class="text-primary"> ~ So Bad Yet, So Good! (｡&gt;﹏&lt;｡) ~ </span>
      </v-col>
    </v-row>
    <v-row align="center" class="text-center mb-5">
      <v-col cols="12" align="start" class="text-start">
        <h2 class="text-left">TL;DR (Long Story) My Journey</h2>
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" align="start" class="text-justify">
        <h3 class="my-5">Why computer science</h3>
        <p style="text-indent: 2em;">
          I've been familiar with computers since I was a child, when internet cafes and multiplayer games were popular in Indonesia.
          I was in 6th grade at the time, and I learned programming because I was interested in creating websites to share online game cheats.
          That's where I learned HTML, JS, VB, and C/C++.
          In high school, I also enjoyed modifying and customizing my Android devices.
          My goal remained the same, gaining root access and ensuring my cheats wouldn't be detected when playing games on my Android device.
        </p>
        <h3 class="my-5">First time working in the real world</h3>
        <p style="text-indent: 2em;">
          In 2019, I interned at PT. Ace Global Consulting & Integrity (a software company under the Indomaret group), 8 to 5, and five days a week.
          I created and developed applications using Java. 
          I learned a lot there because it was a new experience for me.
          I had never used that programming language before, the only programming languages I knew and used daily as a student were C/C++, PHP, and JS.
        </p>
        <p style="text-indent: 2em;">
          After completing my project, I returned to university to continue my studies.
          I also took a part-time job as a front-end engineer to fill my spare time while completing my thesis.
        </p>
        <h3 class="my-5">Graduated from university</h3>
        <p style="text-indent: 2em;">
          After graduating in 2020, I returned to the Indomaret group, but this time I was placed in the parent main company, specifically in the logistics department (with a total of 20 programmers), managing Distribution Center (DC) warehouses spread across various cities in Indonesia.
          Here, we used VB and C# to create various applications, including web, desktop, and mobile, as those were the only programming languages the existing employees were proficient in.
          This was also a new experience for me, as I had never used them before.
          We have always used the ASP.NET Core Framework, so most of our servers are Windows-based (we have on-premises servers, not cloud servers or third-party services).
        </p>
        <p style="text-indent: 2em;">
          Initially, my work was limited to building traditional Windows desktop applications the old-fashioned way, where most executable files (app.exe) typically connected directly to the database.
          Later, we started implementing microservices, and some applications were moved to web pages with REST APIs (while still maintaining the legacy SOAP architecture, as it was still used by other departments).
        </p>
        <h3 class="my-5">My First Project</h3>
        <p style="text-indent: 2em;">
          Because we were using Windows servers, licensing costs were high, and I was asked to manage and migrate some application services to Linux while still using VB and C#.
          As a result, some of the servers currently running Windows were downsized.
          We couldn't completely replace them because we were still using Microsoft SQL Server databases.
          Furthermore, during this project, I began implementing the concept of application containerization during deployment, a practice that continues to this day.
          It wasn't a perfect CI/CD pipeline, but it worked, just by utilizing the limited resources we had (physical CPU, RAM, NET, etc.).
        </p>
        <h3 class="my-5">The Next, DB-Link Problem</h3>
        <p style="text-indent: 2em;">
          Before I joined the company, they were using Clipper DB, which they later migrated to Oracle. 
          However, after I joined the team, they asked me to migrate to PostgreSQL for cost-effective reasons.
          I, along with several other people (still considered new employees and expected to be more familiar with the latest technology), began a trial migration.
          We converted the entire existing table structure, views, functions, procedures, CRON jobs / schedulers, and also created extensions that existed in Oracle but weren't available in PostgreSQL.
          Fortunately, our servers are decentralized, so migrating a DC won't disrupt the others.
        </p>
        <p style="text-indent: 2em;">
          Oracle has a feature called dblink that makes it easy to retrieve data between database servers, for example, from all branches to the head office (actually, PostgreSQL also has one).
          However, since we're starting the migration one branch at a time, I had to think about replacing this feature, as it only works for the same database.
          So, I created a REST API (initially) as a prototype for retrieving data.
          After testing, I found this method unreliable for sending large amounts of data, so I decided to use Kafka and GRPC for data streaming.
          This was a side project that eventually evolved into a serious project and became the main foundation for large-scale, real-time data transfers.
        </p>
        <h3 class="my-5">What now</h3>
        <p style="text-indent: 2em;">
          Currently focused on developing and maintaining applications upon user request (logistics) or fixing bugs in existing programs.
          There likely won't be any more major infrastructure development projects.
          Just reading the requirements, write SQL scripts, code in VB / C#, and chill out 😊 (in Indonesian, "🧨 jaga lilin 🧨 / keep the lights on / 🧨" when we have nothing to do).
        </p>
      </v-col>
    </v-row>
    <v-row align="right" class="text-right my-3">
      <v-col>
        <h5>Last Updated :: 11-10-2025</h5>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'Home',
    data: () => ({
      works: [
        {
          job: '.NET Software Engineer',
          type: 'Full Stack, Full-Time',
          company: 'Indomaret Group',
          industry: 'Warehouse & Logistics.',
          location: 'Jakarta, Indonesia',
          date: '2020 - present',
          image: 'indomaret.jpg',
          description: 'Create and develop warehouse systems, websites and desktop applications, ranging from processing, management, automation, job scheduling, monitoring to reporting, used in all distribution centers on a national scale throughout Indonesia.'
        },
        {
          job: 'Angular Web. Developer',
          type: 'Frond End, Part-Time',
          company: 'MacroAd',
          industry: 'Digital Advertising.',
          location: 'Banten, Indonesia',
          date: '2019 - 2020',
          image: 'macroad.jpg',
          description: 'Create a website that is used by users in general and also a special page for Admin to manage it.'
        },
        {
          job: 'Computer Lab. Assistant',
          type: 'Full Stack, Part-Time',
          company: 'Univ. Multimedia Nusantara',
          industry: 'Teach Programming Course.',
          location: 'Banten, Indonesia',
          date: '2017 - 2019',
          image: 'umn.jpg',
          description: 'Algorithms & Data Structures, Database Systems, Graphics & Animations for game development and Website Development.'
        }
      ],
      projects:[
        {
          name: 'FansubID',
          title: 'Fansub ID Main Site',
          description: 'Indonesian Fansub Database Main Site',
          image: 'https://raw.githubusercontent.com/bifeldy/FansubID/master/projects/main-site/src/assets/img/banner/fansub.png',
          url: 'https://www.fansub.id'
        },
        {
          name: 'email_worker_parser',
          title: 'username @ Fansub . ID',
          description: 'Cloudflare E-Mail :: http://mail.fansub.id',
          image: 'https://raw.githubusercontent.com/bifeldy/FansubID/master/projects/main-site/src/assets/img/banner/berkas.jpg',
          url: null
        },
        {
          name: 'crawler_worker',
          title: 'Rss Feed Crawler',
          description: 'RSS Feed Crawler :: http://crawl.fansub.id',
          image: 'https://raw.githubusercontent.com/bifeldy/FansubID/master/projects/main-site/src/assets/img/banner/news.png',
          url: null
        }
      ],
      papers: [
        {
          title: 'Go-Ethereum for Electronic Voting System Using Clique as Proof-of-Authority',
          description: 'Telkomnika, Vol 19, No 5: October 2021. Pp 1565-1572.',
          url: 'https://dx.doi.org/10.12928/telkomnika.v19i5.20415',
          publisher: 'Telkomnika',
          date: '01 October 2021',
          images: [
            'https://avataaars.io/?avatarStyle=Circle&topType=LongHairFrida&accessoriesType=Kurt&hairColor=Red&facialHairType=BeardLight&facialHairColor=BrownDark&clotheType=GraphicShirt&clotheColor=Gray01&graphicType=Skull&eyeType=Wink&eyebrowType=RaisedExcitedNatural&mouthType=Disbelief&skinColor=Brown',
            'https://avataaars.io/?avatarStyle=Circle&topType=ShortHairFrizzle&accessoriesType=Prescription02&hairColor=Black&facialHairType=MoustacheMagnum&facialHairColor=BrownDark&clotheType=BlazerSweater&clotheColor=Black&eyeType=Default&eyebrowType=FlatNatural&mouthType=Default&skinColor=Tanned',
            'https://avataaars.io/?avatarStyle=Circle&topType=LongHairMiaWallace&accessoriesType=Sunglasses&hairColor=BlondeGolden&facialHairType=Blank&clotheType=BlazerSweater&eyeType=Surprised&eyebrowType=RaisedExcited&mouthType=Smile&skinColor=Pale'
          ]
        },
        {
          title: 'A Secured Online Voting System by Using Blockchain as the Medium',
          description: 'The Smart Cyber Ecosystem for Sustainable Development, Chapter 21.',
          url: 'https://doi.org/10.1002/9781119761655.ch21',
          publisher: 'Scrivener Publishing LLC',
          date: '12 September 2021',
          images: [
            'https://avataaars.io/?avatarStyle=Circle&topType=LongHairDreads&accessoriesType=Prescription01&hairColor=BrownDark&facialHairType=BeardMajestic&facialHairColor=Platinum&clotheType=GraphicShirt&clotheColor=Gray02&graphicType=Skull&eyeType=Default&eyebrowType=UpDown&mouthType=ScreamOpen&skinColor=Black',
            'https://avataaars.io/?avatarStyle=Circle&topType=ShortHairFrizzle&accessoriesType=Prescription02&hatColor=Gray02&hairColor=BrownDark&facialHairType=BeardMajestic&facialHairColor=Blonde&clotheType=Overall&clotheColor=Gray02&graphicType=Diamond&eyeType=Dizzy&eyebrowType=RaisedExcited&mouthType=Vomit&skinColor=Yellow',
            'https://avataaars.io/?avatarStyle=Circle&topType=LongHairFrida&accessoriesType=Sunglasses&hairColor=Brown&facialHairType=MoustacheMagnum&facialHairColor=Blonde&clotheType=ShirtVNeck&clotheColor=Gray02&eyeType=Happy&eyebrowType=RaisedExcitedNatural&mouthType=Serious&skinColor=Tanned',
            'https://avataaars.io/?avatarStyle=Circle&topType=Eyepatch&accessoriesType=Prescription02&hairColor=SilverGray&facialHairType=MoustacheMagnum&facialHairColor=BrownDark&clotheType=Hoodie&clotheColor=Blue03&eyeType=WinkWacky&eyebrowType=Default&mouthType=Tongue&skinColor=Tanned',
            'https://avataaars.io/?avatarStyle=Circle&topType=LongHairStraight&accessoriesType=Round&hairColor=Blue&facialHairType=Blank&facialHairColor=Brown&clotheType=ShirtScoopNeck&clotheColor=Gray01&eyeType=Cry&eyebrowType=Default&mouthType=Sad&skinColor=Pale'
          ]
        }
      ]
    }),
    methods: {
      openUrl: (link) => {
        window.open(link, '_blank');
      }
    }
  }
</script>
